"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const shouldReduceMotion = useReducedMotion();
  const baseTransition = {
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1] as const
  };
  const clauseVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 32
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section data-section-id="31783" id="heroservicesintroduction" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-[168px] pb-[128px] md:pt-[200px] md:pb-[176px]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden md:block" style={{
      backgroundImage: "repeating-linear-gradient(to right, hsl(220 18% 82% / 0.08) 0, hsl(220 18% 82% / 0.08) 1px, transparent 1px, transparent calc(100% / 12))"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      backgroundImage: `
            linear-gradient(hsl(220 18% 82% / 0.14) 1px, transparent 1px),
            linear-gradient(90deg, hsl(220 18% 82% / 0.14) 1px, transparent 1px)
          `,
      backgroundSize: "160px 160px",
      backgroundPosition: "center",
      maskImage: "radial-gradient(circle at center, black 1.5px, transparent 2px)",
      WebkitMaskImage: "radial-gradient(circle at center, black 1.5px, transparent 2px)",
      maskSize: "160px 160px",
      WebkitMaskSize: "160px 160px"
    }} />

      <div className="relative mx-auto w-full max-w-[1240px] px-6 sm:px-8 md:px-12 lg:px-16 text-center">
        {/* Eyebrow */}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        ...baseTransition,
        delay: 0.05
      }} className="mb-8 md:mb-10 flex justify-center">
          <div className="inline-flex items-center gap-2.5 h-8 rounded-lg border px-4 bg-secondary" style={{
          borderColor: "var(--border)"
        }}>
            <span className="inline-block h-1.5 w-1.5 rounded-lg" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="font-mono text-[11px] md:text-[13px] uppercase tracking-[0.16em] text-foreground" style={{
            fontWeight: 500
          }}>
              Independent local pros across the Atlanta area
            </span>
          </div>
        </motion.div>

        {/* Single H1 for the page */}
        <h1 className="mx-auto max-w-[1120px] text-foreground uppercase" style={{
        fontFamily: "var(--font-serif)",
        fontSize: "clamp(2.75rem, 6.2vw, 6rem)",
        fontWeight: 800,
        letterSpacing: "-0.025em",
        lineHeight: 0.98
      }}>
          <motion.span className="block" variants={clauseVariants} initial="hidden" animate="visible" transition={{
          ...baseTransition,
          delay: 0.12
        }}>
            Home Services in Atlanta:
          </motion.span>
          <motion.span className="block text-primary mt-2" variants={clauseVariants} initial="hidden" animate="visible" transition={{
          ...baseTransition,
          delay: 0.24
        }}>
            Appliance Repair, HVAC, Plumbing,
          </motion.span>
          <motion.span className="block text-muted-foreground mt-2" variants={clauseVariants} initial="hidden" animate="visible" transition={{
          ...baseTransition,
          delay: 0.36
        }}>
            Electrical &amp; Maintenance
          </motion.span>
        </h1>

        {/* Hub intro */}
        <motion.p initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        ...baseTransition,
        delay: 0.5
      }} className="mx-auto mt-8 md:mt-10 max-w-[720px] text-base md:text-lg lg:text-xl leading-relaxed" style={{
        color: "var(--muted-foreground)",
        fontWeight: 400,
        letterSpacing: "-0.005em",
        lineHeight: 1.55
      }}>
          Handy Heroes connects Atlanta-area homeowners with independent local trade specialists. Explore dedicated trade categories or request a pro for your neighborhood. Direct quotes are provided by the pro before work begins. For fast questions or to check pros in your ZIP code, call{" "}
          <a href="tel:+14708479076" className="font-medium text-foreground underline decoration-primary underline-offset-4 hover:text-primary transition-colors">
            (470) 847-9076
          </a>
          .
        </motion.p>

        {/* CTA buttons */}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        ...baseTransition,
        delay: 0.62
      }} className="mt-10 md:mt-12 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
          <Button asChild className="h-[52px] rounded-full px-8 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm w-full sm:w-auto" style={{
          letterSpacing: "-0.005em"
        }}>
            <Link to="#quoterequestcta">Request a Quote</Link>
          </Button>

          <Button asChild variant="outline" className="h-[52px] rounded-full px-8 text-sm font-medium bg-transparent border text-foreground hover:bg-accent w-full sm:w-auto" style={{
          borderColor: "var(--border)",
          borderWidth: "1.25px",
          letterSpacing: "-0.005em"
        }}>
            <a href="tel:+14708479076">Call (470) 847-9076</a>
          </Button>
        </motion.div>
      </div>
    </section>;
}